import { createSlice } from "@reduxjs/toolkit";
import { getAllProduct, getAllProductDetail } from "../actions/product";

const initialState = {
  product: [],
  totalcount: 0,
  productDetail: [],
}

const productSlice = createSlice({
  name: "product",
  initialState,

  extraReducers: (builder) => {
    builder.addCase(getAllProduct.pending, (state, action) => {
      state.product = []
    });
    builder.addCase(getAllProduct.fulfilled, (state, action) => {
      state.product = action.payload.list
      state.totalcount = action.payload.total
    });
  },
  reducers: {
    createProductRecord: (state, action) => {
      state.product.unshift(action.payload)
    },
    updateRecord: (state, action) => {
      const getIndex = state.product.findIndex(item => item.id == action.payload.id)
      state.product[getIndex] = action.payload;
    },
    updateProductDetailRecord: (state, action) => {
      const getIndex = state.productDetail.findIndex(item => item.productID == action.payload.productID)
      state.productDetail[getIndex] = action.payload;
    },
    deleteRecord: (state, action) => {
      const getIndex = state.product.findIndex(item => item.id == action.payload.ID)
      state.product.splice(getIndex, 1)
    },
  },
});
export default productSlice.reducer;
export const { createProductRecord, updateRecord, updateProductDetailRecord, deleteRecord } = productSlice.actions;
